// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__Kg0HV","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__9lEa5"};